import React, { Component } from 'react';
import { connect } from 'react-redux';
import TransactionContainer from '../transactionDetails/transaction';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedDate from '../fields/dates/FormattedDate';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import NoData from '../page/NoData';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import { SSelect } from "@avalara/skylab-sdk/react";
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
const log = new Logger('TRANSACTION_SEARCH_RESULTS_ITEM', LOG_LEVELS.DEBUG);

class TransactionSearchResultItem extends Component {

  constructor(props) {
    super(props);
    this.onLineActionHandler = this.onLineActionHandler.bind(this);
    this.state = {
      selection: new Map(),
      showExpand: false,
      summarySize: "7"
    };
  }

  onChange(event) {
    log.debug('onChange():  ', event);
    if (typeof this.props.onSelect === 'function') return this.props.onSelect(event.target.checked);
  }

  expandRowClick() {
    this.setState({
      showExpand: !this.state.showExpand
    });
  }

  getLineActionOptions(transaction) {
    const selectedLineActionVal = this.state.selection.get(transaction.id) ? this.state.selection.get(transaction.id).lineAction : "";
    const optionsList = [{
      label: LANGUAGE_CONTROLLER.format(this.props.languageString, "transactionSearchResults_Actions_SelectAction"),
      value: "",
      selected: !selectedLineActionVal ? true : false
    }, {
      label: LANGUAGE_CONTROLLER.format(this.props.languageString, "transactionSearchResults_Actions_Delete"),
      value: "delete",
      selected: selectedLineActionVal === "delete" ? true : false
    }, {
      label: LANGUAGE_CONTROLLER.format(this.props.languageString, "transactionSearchResults_Actions_ForceToError"),
      value: "forceToError",
      selected: selectedLineActionVal === "forceToError" ? true : false
    }, {
      label: LANGUAGE_CONTROLLER.format(this.props.languageString, "transactionSearchResults_Actions_Redeliver"),
      value: "redeliver",
      selected: selectedLineActionVal === "redeliver" ? true : false
    }, {
      label: LANGUAGE_CONTROLLER.format(this.props.languageString, "transactionSearchResults_Actions_Export"),
      value: "export",
      selected: selectedLineActionVal === "export" ? true : false
    }];
    return optionsList;
  }

  onLineActionHandler(transactionId) {
    return (event) => {
      // Guard: Click outside - item is undefined
      if (!event?.detail?.item) {
        return;
      }

      const selectedAction = event.detail.item.value;

      // Guard: Same value selected - no change needed
      const currentAction = this.state.selection.get(transactionId)?.lineAction || '';
      if (selectedAction === currentAction) {
        return;
      }

      let selection = new Map(this.state.selection);
      selection.set(transactionId, { lineAction: selectedAction });
      this.setState({
        selection: selection
      });
      if (typeof this.props.onLineAction === 'function') {
        this.props.onLineAction(transactionId, event);
      }
    };
  }

  renderHeader() {
    if (!this.props.header) return null;

    return (
      <s-row>
        {this.renderHeaderInvoiceNumber()}
        {this.renderHeaderCheckbox()}
        {this.renderHeaderSummary()}
        {this.renderHeaderActions()}
      </s-row>
    );
  }

  renderHeaderInvoiceNumber() {
    if (!this.props.allowSelection) return null;

    return (
      <s-col span="2" class="pb0">
        <span className="small uppercase">
          <LanguageStringResolver string="transactionSearchResultsColumnHeading_InvoiceNumber" />
        </span>
      </s-col>
    );
  }

  renderHeaderCheckbox() {
    if (!this.props.allowSelection) return null;

    return (
      <s-col span="1" class="pb0">
        <fieldset>
          <span className="tickBox">
            {this.props.formInitialising ? (
              <span></span>
            ) : (
              <span>
                <input
                  className="checkbox absolute m0"
                  checked={this.props.selected}
                  type="checkbox"
                  onChange={this.onChange.bind(this)}
                />
                <label className="ml15 checkbox"></label>
              </span>
            )}
          </span>
        </fieldset>
      </s-col>
    );
  }

  renderHeaderSummary() {
    const spanSize = this.props.allowSelection ? "7" : "12";

    return (
      <s-col span={spanSize} class="pb0">
        <span className="small uppercase">
          <LanguageStringResolver string="transactionSearchResultsColumnHeading_Summary" />
        </span>
      </s-col>
    );
  }

  renderHeaderActions() {
    if (!this.props.allowSelection) return null;

    return (
      <s-col span="2" class="pb0">
        <span className="small uppercase">
          <LanguageStringResolver string="transactionSearchResultsColumnHeading_Actions" />
        </span>
      </s-col>
    );
  }

  renderNoData() {
    if (!this.props.none) return null;

    return (
      <div>
        <NoData noDataText="transactions_NoData" />
      </div>
    );
  }

  renderInvoiceNumberColumn(transaction) {
    if (!this.props.allowSelection) return null;

    const isInitializing = this.props.formInitialising || transaction.id === null;

    return (
      <s-col span="2" class="pb0">
        {isInitializing ? (
          <p className="p0 word-break-all">{transaction.display.invoiceNumber}</p>
        ) : (
          <span className="expand-title">
            <button
              className={`expandable link expand height-fit-content ${this.state.showExpand}`}
              onClick={() => this.expandRowClick()}
            >
              <span className="word-break-all">
                <s-icon class="mr0" name="chevron-down"></s-icon>
                {transaction.display.invoiceNumber}
              </span>
            </button>
          </span>
        )}
      </s-col>
    );
  }

  renderSelectionColumn(transaction) {
    if (!this.props.allowSelection) return null;

    const isInitializing = this.props.formInitialising || transaction.id === null;

    return (
      <s-col span="1" class="pb0">
        <fieldset>
          <span className="tickBox">
            {isInitializing ? (
              <span></span>
            ) : (
              <span>
                <input
                  className="checkbox absolute m0"
                  disabled={!transaction.display.invoice}
                  checked={this.props.selected}
                  type="checkbox"
                  onChange={this.onChange.bind(this)}
                />
                <label className="ml15 checkbox"></label>
              </span>
            )}
          </span>
        </fieldset>
      </s-col>
    );
  }

  renderTransactionTable(transaction) {
    return (
      <table className="borderless m0">
        <tbody>
          <tr className="vertical-align-top">
            <td className="quarter-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_InvoiceDate" />: </span></p>
            </td>
            <td className="quarter-width">
              <p className="pr10"><span className="semi-bold word-break-all"><FormattedDate value={transaction.display.doc.invoiceDate} /></span></p>
            </td>
            <td className="thirty-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_SupplierInvoiceNumber" />: </span></p>
            </td>
            <td className="twenty-width">
              <p className="pr10"><span className="semi-bold word-break-all">{transaction.display.doc.supplierInvoice}</span></p>
            </td>
          </tr>
          <tr className="vertical-align-top">
            <td className="quarter-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_TransactionDate" />: </span></p>
            </td>
            <td className="quarter-width">
              <p className="pr10"><span className="semi-bold word-break-all"><FormattedDate value={transaction.display.doc.transactionDate} /></span></p>
            </td>
            <td className="thirty-width">
              <p><span className="uppercase float-left"><LanguageStringResolver string="transactionSearchResults_Total" />: </span></p>
            </td>
            <td className="twenty-width">
              <p className="pr10"><span className="semi-bold word-break-all"><FormattedCurrencyValue className="float-left ml5 mr5" value={transaction.display.doc.total} rightAlign={false} /> {transaction.display.doc.currency}</span></p>
            </td>
          </tr>
          <tr className="vertical-align-top">
            <td className="quarter-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_Supplier" />: </span></p>
            </td>
            <td className="quarter-width">
              <p className="pr10"><span className="semi-bold word-break-all">{transaction.display.doc.supplier}</span></p>
            </td>
            <td className="thirty-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_DocumentType" />: </span></p>
            </td>
            <td className="twenty-width">
              <p className="pr10"><span className="semi-bold word-break-all">{transaction.display.doc.type}</span></p>
            </td>
          </tr>
          <tr className="vertical-align-top">
            <td className="quarter-width">
              <p><span className="uppercase"><LanguageStringResolver string="transactionSearchResults_Customer" />: </span></p>
            </td>
            <td className="quarter-width">
              <p className="pr10"><span className="semi-bold word-break-all">{transaction.display.doc.customer}</span></p>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderMessages(transaction) {
    const hasMessages = transaction.display.messages.length > 0 || transaction.display.summary.length > 0;
    if (!hasMessages) return <div></div>;

    return (
      <div>
        <div className={transaction.invoice ? "p5 border-top" : "p5"}>
          {transaction.display.messages.map((item, index) => (
            <p key={index} className="mb0 semi-bold">{item}</p>
          ))}
          {transaction.display.summary.map((item, index) => (
            <p key={index} className="mb0 semi-bold">{item}</p>
          ))}
        </div>
      </div>
    );
  }

  renderSummaryColumn(transaction, summarySize) {
    return (
      <s-col span={summarySize}>
        {transaction.invoice && (
          <div>
            <div>
              {this.renderTransactionTable(transaction)}
            </div>
          </div>
        )}
        {this.renderMessages(transaction)}
      </s-col>
    );
  }

  renderActionColumn(transaction) {
    if (!this.props.allowSelection) return null;

    const isInitializing = this.props.formInitialising || transaction.id === null;

    return (
      <ReadOnlyWrapper>
        <s-col span="2">
          <fieldset>
            {isInitializing ? (
              <span></span>
            ) : (
              <SSelect
                defaultValue={this.state.selection.get(transaction.id) ? this.state.selection.get(transaction.id).lineAction : ''}
                inputId="single-reportType-select"
                name="reporttype"
                onS-select={this.onLineActionHandler(transaction.id)}
                optionsList={this.getLineActionOptions(transaction) || []}
                readonlyExemptValues={["", "export"]}
                multiple={false}
                showSelectionCount={false}
              />
            )}
          </fieldset>
        </s-col>
      </ReadOnlyWrapper>
    );
  }

  renderExpandedView(transaction) {
    if (!this.state.showExpand) return <div></div>;

    return (
      <div className="toggle-container">
        {transaction.invoice && (
          <s-row>
            <s-col span="12">
              <TransactionContainer
                transactionDetails={transaction.invoice}
                warnings={transaction.display.warnings}
                deleteLogs={transaction.display.summary}
              />
            </s-col>
          </s-row>
        )}
      </div>
    );
  }

  render() {
    log.debug('render(): ', this.props);

    // Calculate summary column size based on selection availability
    const summarySize = this.props.allowSelection ? "7" : "12";
    log.debug('summarySize(): ', summarySize);

    // Handle different render states
    const headerContent = this.renderHeader();
    if (headerContent) return headerContent;

    const noDataContent = this.renderNoData();
    if (noDataContent) return noDataContent;

    // Render main transaction content
    const transaction = this.props.transaction || {};

    return (
      <div>
        <s-row>
          {this.renderInvoiceNumberColumn(transaction)}
          {this.renderSelectionColumn(transaction)}
          {this.renderSummaryColumn(transaction, summarySize)}
          {this.renderActionColumn(transaction)}
        </s-row>
        {this.renderExpandedView(transaction)}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetAllActionToDefault !== prevProps.resetAllActionToDefault) {
      if (this.props.resetAllActionToDefault) {
        this.setState({
          selection: new Map()
        })
      }
    }
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state);
  return {
  };
}


TransactionSearchResultItem.defaultProps = {
  none: false,
  header: false,
  formInitialising: false,
  selected: false,
  allowSelection: true,
  disableLinks: false,
  onSelect: () => { },
  resetAllActionToDefault: false
};

// Named export for testing
export { TransactionSearchResultItem };

export default connect(mapStateToProps)(TransactionSearchResultItem);